import { Tabs } from "@mantine/core";
import React from "react";

const CustomTabs = ({ tabs, activeTab, onChange }) => {
  return (
    <Tabs
      value={activeTab}
      onChange={onChange}
      color="blue"
      variant="pills"
      radius="md"
      classNames={{
        tab: "!text-sm !bg-gray-400/10 hover:!bg-gray-400/20 aria-selected:!bg-orange-600 dark:!bg-gray-400/10 dark:aria-selected:!bg-orange-800 ",
      }}
    >
      <Tabs.List className="flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <Tabs.Tab key={tab.value} value={tab.value}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};

export default CustomTabs;
